export const QA_NAME_APPLICANT_PROFILE_WIDGET_STAGE_SCREENING =
  'applicantProfileWidgetStageScreening'

export const QA_NAME_APPLICANT_PROFILE_STAGE_MIRROR =
  'applicantProfileStageMirror'

export const APPLICANT_STAGE_SCREENING_GROUP = {
  decision: 'decision',
  screening: 'screening',
}

export const APPLICANT_CHECK_KEY = {
  documents: 'documents',
  fourEyes: 'four_eyes',
  sanctions: 'sanctions',
  selected: 'selected',
}

export const APPLICANT_SCREENING_NOT_STARTED_STATUS = {
  text: 'RentalPortal.ApplicantProfileComplianceNotStartedKey',
  textColor: 'var(--secondary-text-color)',
}

export const APPLICANT_SCREENING_CLEARED_STATES = [
  'clear',
  'cleared_false_positive',
]

export const APPLICANT_STAGE_SCREENING_SKELETON_GROUP_ROW_COUNT = [2, 2]
